import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { module: 'home' }, // meta: {requiresAuth: true }
  },
  {
    path: '/institucional',
    name: 'institucional',
    meta: { module: 'institucional' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InstitucionalView.vue')
  },
  {
    path: '/institucional/preguntas_frecuentes',
    name: 'institucional-faq',
    meta: { module: 'institucional' },
    component: () => import(/* webpackChunkName: "about" */ '../views/InstitucionalFaqView.vue')
  },
  {
    path: '/institucional/documentos',
    name: 'institucional-documentos',
    meta: { module: 'institucional' },
    component: () => import(/* webpackChunkName: "about" */ '../views/InstitucionalDocumentosView.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    meta: { module: 'contacto' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactoView.vue')
  },
  {
    path: '/nivel_inicial',
    name: 'nivel_inicial',
    meta: { module: 'nivel_inicial' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelInicialView.vue')
  },
  {
    path: '/nivel_inicial/prepos',
    name: 'nivel_inicial_prepos',
    meta: { module: 'nivel_inicial_prepos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelInicialPreposView.vue')
  },
  {
    path: '/nivel_primario',
    name: 'nivel_primario',
    meta: { module: 'nivel_primario' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelPrimarioView.vue')
  },
  {
    path: '/nivel_primario/recursos',
    name: 'nivel_primario_recursos',
    meta: { module: 'nivel_primario_recursos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelPrimarioRecursosView.vue')
  },
  {
    path: '/nivel_primario/contenido/:id?',
    name: 'nivel_primario_contenido',
    meta: { module: 'nivel_primario_contenido' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelPrimarioContenidoView.vue')
  },
  {
    path: '/nivel_secundario',
    name: 'nivel_secundario',
    meta: { module: 'nivel_secundario' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelSecundarioView.vue')
  },
  {
    path: '/nivel_secundario/recursos',
    name: 'nivel_secundario_recursos',
    meta: { module: 'nivel_secundario_recursos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelSecundarioRecursosView.vue')
  },
  {
    path: '/nivel_secundario/examenes',
    name: 'nivel_secundario_examenes',
    meta: { module: 'nivel_secundario_examenes' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelSecundarioExamenesView.vue')
  },
  {
    path: '/pastoral',
    name: 'pastoral',
    meta: { module: 'pastoral' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralView.vue')
  },
  {
    path: '/pastoral/diasimportantes/',
    name: 'pastoral_diasimportantes',
    meta: { module: 'pastoral/diasimportantes' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralDiasImportantesView.vue')
  },
  {
    path: '/pastoral/alpha/',
    name: 'pastoral/alpha',
    meta: { module: 'pastoral/alpha' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralAlphaView.vue')
  },
  {
    path: '/pastoral/preju/',
    name: 'pastoral/preju',
    meta: { module: 'pastoral/preju' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralPrejuView.vue')
  },
  {
    path: '/pastoral/catequesis/',
    name: 'pastoral/catequesis',
    meta: { module: 'pastoral/catequesis' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralCatequesisView.vue')
  },
  {
    path: '/pastoral/novedades/',
    name: 'pastoral/novedades',
    meta: { module: 'pastoral/novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralNovedadesView.vue')
  },
  {
    path: '/pastoral/novedades/:id?',
    name: 'pastoral/novedades',
    meta: { module: 'pastoral/novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralNovedadesView.vue')
  },
  {
    path: '/novedades',
    name: 'novedades',
    meta: { module: 'novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NovedadesView.vue')
  },
  {
    path: '/novedades/:id?',
    name: 'novedad',
    meta: { module: 'novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NovedadesView.vue')
  },
  {
    path: '/eventos',
    name: 'eventos',
    meta: { module: 'eventos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EventosView.vue')
  },
  {
    path: '/eventos/:id?',
    name: 'evento',
    meta: { module: 'eventos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EventosView.vue')
  },
  {
    path: '/proyecto',
    name: 'proyecto',
    meta: { module: 'proyecto' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ProyectoEducativoView.vue')
  },
  {
    path: '/admisiones',
    name: 'admisiones',
    meta: { module: 'admisiones' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdmisionesView.vue')
  },
  {
    path: '/administracion',
    name: 'administracion',
    meta: { module: 'administracion' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministracionView.vue')
  },
  {
    path: '/administracion/faq',
    name: 'administracion-faq',
    meta: { module: 'administracion' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministracionFaqView.vue')
  },
  {
    path: '/autogestion',
    name: 'autogestion',
    meta: { module: 'autogestion' }, //, requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/AutogestionView.vue')
  },
  {
    path: '/actividades_extraprogramaticas',
    name: 'activiadades-extra',
    meta: { module: 'actividades_extraprogramaticas' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ActividadesExtraprogramaticasView.vue')
  },
  {
    path: '/cv',
    name: 'cv',
    meta: { module: 'cv' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EnviaCurriculumView.vue')
  },
  {
    path: '/doe',
    name: 'doe',
    meta: { module: 'doe' },
    component: () => import(/* webpackChunkName: "about" */ '../views/DoeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  { //Default Catch all
    path: '/:pathMatch(.*)*',
    name: 'NotFoundOrDynamic',
    component: import('../views/DefaultView.vue')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Store route metadata in Vuex store
  store.dispatch('setRouteMeta', to.meta)

  if (to.meta.requiresAuth && !store.getters.isLoggedIn) {
    next({ name: 'login' }) // redirect to login page
  } else {
    next()
  }
})

export default router
